import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { useSettings } from "@/context/SettingsContext";
import { Logo } from "@/components/Logo";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const settings = useSettings();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToSection = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/90 backdrop-blur-xl border-b border-white/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <button
          onClick={() => goToSection("home")}
          data-testid="navbar-logo-button"
          className="flex items-center"
        >
          <Logo height={settings.nav_logo_height} />
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => goToSection(link.id)}
              data-testid={`nav-link-${link.id}`}
              className="text-white/75 hover:text-white transition-colors text-sm font-medium tracking-wide relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-[#FF1A1A] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
          <button
            onClick={() => goToSection("contact")}
            data-testid="nav-cta-button"
            className="bg-[#FF1A1A] text-white px-6 py-2.5 text-sm font-semibold hover:bg-[#E60000] transition-colors"
          >
            Offerte
          </button>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#050505]/98 backdrop-blur-xl border-t border-white/10 mt-3">
          <div className="flex flex-col px-6 py-6 gap-5">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                onClick={() => goToSection(link.id)}
                data-testid={`mobile-nav-link-${link.id}`}
                className="text-left text-white/80 hover:text-white text-lg font-medium"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => goToSection("contact")}
              className="bg-[#FF1A1A] text-white px-6 py-3 font-semibold mt-2"
              data-testid="mobile-nav-cta"
            >
              Gratis offerte
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
